import axios from "axios";
// import config from "@/utils/config";
let showLoading = false; // 是否允许显示toast和loading
// 无须登录的接口, {route: [interface]}
// const commonAddressInterface = "ddh.carlife.intelligent.delivery.address.byuser.get";
// const withoutLoginInterface = {
//   common: [commonAddressInterface]
// };
//创建一个axios实例
const AxiosInstance = axios.create({
  withCredentials: true
});
// 请求开始时，开启加载中动画，出错了提示并关闭动画
AxiosInstance.interceptors.request.use(
  config => {
    if (showLoading) {
      window.vm.$toast.loading({
        mask: true,
        duration: 0
      });
    }
    return config;
  },
  error => {
    if (window.vm) {
      window.vm && window.vm.$toast("请求超时!");
    }
    showLoading && window.vm.$toast.clear();
    return Promise.reject(error);
  }
);

// 请求完成时，关闭加载中动画，返回数据或错误信息
AxiosInstance.interceptors.response.use(
  response => {
    showLoading && window.vm.$toast.clear();
    const {
      config: { data: configData },
      data: { code, message, data }
    } = response;
    let thisMethod = "";
    if (window.vm) {
      thisMethod = window.vm.myUtils.getConfigData(configData, "method");
    }

    switch (+code) {
      case 0:
        return Promise.resolve(data);
      case 21 || 20: {
        window.vm.$store.dispatch("init/clear");
        const { withoutLoginInterface } = AxiosInstance.defaults
        // 特定接口不用跳转去登录
        let common = withoutLoginInterface["common"];
        for (let i in withoutLoginInterface) {
          if (
            thisMethod &&
            (common.includes(thisMethod) ||
              (window.vm.$route.path.includes(i) && withoutLoginInterface[i].includes(thisMethod)))
          ) {
            return;
          }
        }
        // 登录失效，跳转登录
        window.jump({ type: 0 });
        return;
      }
      default:
        window.vm.$toast(message);
        return Promise.reject(message);
    }
  },
  error => {
    const { response, message } = error;
    showLoading && window.vm.$toast.clear();
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内，有错误信息则弹出错误信息
      console.error("response-error-data", response.data);
    } else {
      // 什么数据都没有，直接出错了
      window.vm.$toast(message);
      console.error("Error", message);
    }
    return Promise.reject(error);
  }
);

export default {
  // 不带 loading 的 get 请求
  get(url) {
    showLoading = false;
    return AxiosInstance({
      method: "get",
      url: url
    });
  },
  // 不带 loading 的 post 请求
  post(url, params) {
    showLoading = false;
    return AxiosInstance({
      method: "post",
      url: url,
      data: params
    });
  },

  // 带 loading 的 get 请求
  getWithLoading(url) {
    showLoading = true;
    return AxiosInstance({
      method: "get",
      url: url
    });
  },

  // 带 loading 的 post 请求
  postWithLoading(url, params) {
    showLoading = true;
    return AxiosInstance({
      method: "post",
      url: url,
      data: params
    });
  },
  init: function({ baseURL, timeout,withoutLoginInterface }) {
    AxiosInstance.defaults.baseURL = baseURL;
    AxiosInstance.defaults.timeout = timeout;
    AxiosInstance.defaults.withoutLoginInterface = withoutLoginInterface
  }
};
